import {Component, Input, OnInit} from '@angular/core';
import {BoosterService} from "../services/booster.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../user/user-subscription";
import {takeUntil} from "rxjs/operators";
import {BoosterPage} from "../mappers/booster-page";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-subscription-block',
    templateUrl: './subscription-block-with-pages.component.html',
    styleUrls: ['./subscription-block-with-pages.component.scss'],
    standalone: false
})
export class SubscriptionBlockWithPagesComponent implements OnInit {

  @Input() userSubscription: UserSubscription;
  @Input() websiteId: number;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public optimizedPages: BoosterPage[] | null = [];
  public notOptimizedPagesCount: any;
  public pagesCount: number;
  public optimizedPagesLimit: number;
  public isMobile: boolean;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _boosterService: BoosterService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnInit() {
    this.optimizedPagesLimit = this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.services && this.userSubscription.plan.services.speed_optimizer && this.userSubscription.plan.services.speed_optimizer.speed_optimizier_optimizable_pages_max_count && parseInt(this.userSubscription.plan.services.speed_optimizer.speed_optimizier_optimizable_pages_max_count.parameter_value, 10);
    this._getPages();
  }

  private _getPagesCount(): void {
    this._store.select(fromStore.getWebsiteBoosterPagesCount(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(pagesCount => {
        if (!TypeUtils.isNull(pagesCount)) {
          this.pagesCount = TypeUtils.isDefined(pagesCount) ? pagesCount : null;
          this.notOptimizedPagesCount = this.optimizedPages && this.pagesCount > this.optimizedPages.length ? this.pagesCount - this.optimizedPages.length : 0;
        }
      });
  }

  private _getPages(): void {
    this._store.select(fromStore.getWebsiteBoosterPages(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(pages => {
        if (!TypeUtils.isNull(pages))  {
          this.optimizedPages = pages;
          this._getPagesCount();
        }
      });
  }

  public redirectToPages(): void {
    this._router.navigate([`../pages`], {relativeTo: this._route});
  }
}
